export enum AccountImportCodeOptionEnum {
  None = 0,
  Shipping = 1,
  Program = 2,
  Both = 3,
}

export enum ActiveStatusEnum {
  Active = 1,
  Hold = 2,
  Phaseout = 3,
  Inactive = 4,
}

export enum AccountConsolidationStatusEnum {
  Draft = 1,
  Committed = 2,
  Failed = 3,
  Abandoned = 4,
}

export enum AccountConsolidationDecisionEnum {
  Map = 1,
  Skip = 2,
}

export enum AccountConsolidationItemTypeEnum {
  User = 1,
  Admin = 2,
  PugMap = 3,
  ShippingMap = 4,
  AddonMap = 5,
}

export enum GenderEnum {
  NotSpecified = 0,
  Male = 1,
  Female = 2,
}

export enum CancellationReasonTypeEnum {
  NoLongerNeeded = 0,
  OrderedInError = 1,
  Other = 2,
}

export enum CancellationRequestStatusEnum {
  Setup = 0,
  AwaitingSubmission = 1,
  SupplierInProcess = 2,
  Complete = 3,
}

export enum CancellationRequestDetailStatusEnum {
  Setup = 0,
  AwaitingSubmission = 1,
  SupplierInProcess = 2,
  SupplierRejected = 3,
  SupplierAccepted = 4,
}

export enum CatalogFeedEnum {
  SanMar = 1,
  CatalogSync = 2,
  WorkwearOutfitters = 3,
  PromoStandards = 4,
}

export enum LogTypeEnum {
  Unknown = 0,
  Add = 1,
  Update = 2,
  Delete = 3,
  CriticalAdd = 4,
  CriticalUpdate = 5,
  CriticalDelete = 6,
}

export enum CollectionScopeEnum {
  ProgramWide = 10,
  ProgramUserGroupWide = 20,
}

export enum DocSubmitTypeEnum {
  Print = 0,
  Email = 1,
  PrintAndEmail = 2,
  None = 3,
}

export enum DurationUnitOfMeasureEnum {
  Days = 0,
  Weeks = 1,
  Months = 2,
  Years = 3,
}

export enum GuidelineContextEnum {
  ProgramReview = 1,
}

export enum GuidelineSeverityEnum {
  Block = 1,
  Warn = 2,
}

export enum JobOrderStatusEnum {
  Setup = 0,
  AwaitingApproval = 1,
  Rejected = 2,
  AwaitingPlacement = 3,
  Placed = 4,
  OnHold = 5,
  Closed = 6,
  Cancelled = 7,
  AwaitingRelease = 8,
  Invalid = -1,
}

export enum JobOrderTypeEnum {
  EmployeeOrder = 0,
  AdminOrder = 1,
}

export enum ShipFrequencyEnum {
  Daily = 0,
  EveryWeek = 1,
  Every2Weeks = 2,
  Every3Weeks = 3,
  WhenBinIsFull = 99,
}

export enum JobOrderNoteTypeEnum {
  Other = 0,
  PodNote = 1,
  OrderCreated = 2,
  OrderEdited = 3,
  CheckoutReverted = 4,
  SubmittedForApproval = 5,
  ResubmittedAfterRevert = 6,
  ViolationExplanation = 7,
  ApproverQtyChange = 8,
  ApproverLineRemoval = 9,
  OrderApproved = 10,
  OrderApprovedWithViolation = 11,
  OrderRejected = 12,
  RejectionReason = 13,
  OrderReverted = 14,
  RevertReason = 15,
  PcardAssignedAuto = 16,
  PcardAssignedManually = 17,
  PurchaseOrderAssigned = 18,
  PersonalCardPendingHold = 19,
  PersonalCardCharged = 20,
  PersonalCardRejected = 21,
  PersonalCardError = 22,
  OveragePaymentNotCharged = 23,
  OveragePaymentInvalidatedByEdit = 24,
  SubmittedToSupplier = 25,
  SupplierSubmissionFailed = 26,
  ShippingAddressChanged = 27,
  OrderClosed = 28,
  CancellationSubmitted = 29,
  DetailCancelled = 30,
  CancellationRejected = 31,
  DetailUncancel = 32,
  HeaderCancelled = 33,
  ReturnRequested = 34,
  ReturnAcknowledged = 35,
  ReturnReceived = 36,
  ReturnRejected = 37,
  RestockCharged = 38,
  RestockWaived = 39,
  ReissueQtySet = 40,
  CreditMemo = 41,
  UserDeauthorized = 42,
  UserComment = 43,
  ProgramUserGroupRepointed = 44,
  ReturnAccepted = 100,
  ReturnRoutedToAccountOwned = 110,
  CreditMemoIssued = 120,
  PrepaymentRefunded = 130,
  PCardRefunded = 140,
  ReturnManuallyClosed = 150,
  OrderCollected = 200,
  OrderReleased = 210,
  OrderWithdrawnFromCollection = 220,
}

export enum JobOrderOveragePaymentStatusEnum {
  Created = 0,
  Paid = 1,
  Void = 2,
  Refunded = 3,
  IsRefund = 4,
  Cancelled = 5,
}

export enum SupplierSubmissionStatusEnum {
  New = 0,
  Edited = 1,
  Sent = 2,
}

export enum ManufacturerFeedStatusEnum {
  None = 1,
  Setup = 2,
  Committed = 3,
}

export enum NotificationEventEnum {
  JobOrderApprovalSubmission = 10,
  JobOrderSupplierSubmission = 11,
  JobOrderRejected = 12,
  JobOrdersAwaitingApprovalForLongerThan = 13,
  JobOrdersPlacedAfter = 14,
  JobOrderReverted = 15,
  OpenApprovals = 16,
  ReturnRequestSubmission = 20,
  ReturnRequestStatusUpdate = 21,
  CancellationRequestSubmission = 30,
  CancellationRequestStatusUpdate = 31,
  CollectionSubmitReminder = 40,
  CollectionOutstandingDigest = 41,
  EmailHeader = 101,
  EmailFooter = 102,
  FreeForm = 1000,
}

export enum NotificationQueryEnum {
  JobOrder = 1,
  JobOrderList = 2,
  JobOrdersAwaitingApprovalLongerThan = 3,
  OpenApprovals = 4,
  ReturnRequest = 11,
  CancellationRequest = 21,
  CollectionSubmitReminder = 40,
  CollectionOutstandingUsers = 41,
  AccountHelp = 110,
  SupplierHelp = 120,
  AccountUser = 200,
  FreeForm = 1000,
}

export enum NotificationTypeEnum {
  Email = 0,
  SMS = 1,
  InApp = 2,
}

export enum NotificationStatusEnum {
  NotYetSubmitted = 0,
  Pending = 1,
  Complete = 2,
  TimeoutError = 3,
  SubmissionError = 4,
}

export enum StockConditionEnum {
  Available = 0,
  InStock = 1,
  PhaseOut = 2,
  Unavailable = 3,
}

export enum ProgramViolationRuleEnum {
  Warn = 0,
  Stop = 1,
}

export enum ProgramAllowanceRemainderRuleEnum {
  RemainingAllowanceAddedToNewAllowances = 0,
  RemainingAllowancesLost = 1,
}

export enum ProgramPcardTypeEnum {
  None = 0,
  ByAdminPerOrder = 1,
  ByProgram = 2,
  ByProgramUserGroup = 3,
}

export enum ProgramPurchaseOrderTypeEnum {
  None = 0,
  ByAdminPerOrder = 1,
  ByProgram = 2,
  ByProgramUserGroup = 3,
}

export enum ProgramStartDateTypeEnum {
  FixedStartAndEndDate = 0,
  VariableStartAndEndDate = 1,
  VariableStartFixedEndDate = 2,
}

export enum ProgramTypeEnum {
  Managed = 0,
  Compliance = 1,
  Storefront = 2,
  Inventory = 3,
}

export enum ReviewResolutionEnum {
  Open = 1,
  Fixed = 2,
  Accepted = 3,
  Dismissed = 4,
}

export enum ProximityAreaEnum {
  GlobalAdmin = 0,
  Accounts = 1,
  Suppliers = 2,
  AccountUsers = 3,
}

export enum ProximityRightEnum {
  Unknown = 0,
  IsGlobalAdminForAccounts = 1,
  IsGlobalAdminForSuppliers = 2,
  CanManageAccountAdministration = 10,
  CanManageAccountOrganization = 11,
  CanEditProgram = 12,
  CanCreateProgram = 13,
  CanEditAccountHelp = 14,
  IsInAllApprovalTrees = 15,
  CanEditUserByApprovalTree = 20,
  CanEditJobOrderByApprovalTree = 21,
  CanApproveJobOrderByApprovalTree = 22,
  CanImpersonateUsersByApprovalTree = 23,
  CanManageSupplierAdministration = 30,
  CanManageSupplierProducts = 31,
  CanManageSupplierPartnerships = 32,
  CanCreateJobOrders = 50,
  CanEditOwnData = 51,
  Last = 52,
}

export enum ReturnReasonTypeEnum {
  Return = 0,
  Repair = 1,
}

export enum ReturnRequestStatusEnum {
  Setup = 0,
  AwaitingSubmission = 1,
  SupplierInProcess = 2,
  Complete = 3,
}

export enum ReturnRequestDetailStatusEnum {
  Setup = 0,
  AwaitingSubmission = 1,
  SupplierAwaitingReturn = 2,
  SupplierInProcess = 3,
  SupplierRejected = 4,
  SupplierAccepted = 5,
}

export enum SupplierImageRoleEnum {
  Swatch = 1,
  ColorPrimary = 2,
  ColorThumbnail = 3,
  ModelFront = 4,
  ModelBack = 5,
  ModelSide = 6,
  ModelThreeQuarter = 7,
  FlatFront = 8,
  FlatBack = 9,
  StylePrimary = 10,
  StyleThumbnail = 11,
  StyleSwatchSheet = 12,
  BrandLogo = 13,
  SpecSheet = 14,
  AdditionalView = 15,
}

